import { ExpiredLicensesRepository } from 'common/repositories/index';

/**
 * Expired licenses Processor - Expired licenses sorted by expiration date
 */

let processedExpiredLicenses = [];
const observableProcessedExpiredLicenses = new Rx.BehaviorSubject(processedExpiredLicenses);

/**
* @ngdoc service
* @name processors.ExpiredLicensesProcessor
*
* @description
* This class is used to process expired licenses.
*/

const ExpiredLicensesProcessor = {

    /**
     * Replace all expired licenses with received data
     * @param {Array} data
     */
    onNext(data) {

        processedExpiredLicenses = [];

        processedExpiredLicenses = data.sort(this.sortExpiredLicenses);

        observableProcessedExpiredLicenses.onNext(processedExpiredLicenses);

    },

    /**
     * Sort expired licenses by expiration date
     * @param {Array} data
     */
    sortExpiredLicenses(currentLicenseInArray, nextLicenseInArray) {

        if (
            moment(currentLicenseInArray.attributes.expiration_date) >=
            moment(nextLicenseInArray.attributes.expiration_date)
        ) {

            return -1;

        }

        return 1;

    },

    /**
     * @ngdoc function
     * @name processors.ExpiredLicensesProcessor#getAll
     * @methodOf processors.ExpiredLicensesProcessor
     * @function
     *
     * @description
     * This function can be used to return all processed expired licenses.
     *
     * @returns {Array} all processed expired licenses
     */
    getAll() {

        return processedExpiredLicenses;

    },

    /**
    * @ngdoc function
    * @name processors.ExpiredLicensesProcessor#getObservable
    * @methodOf processors.ExpiredLicensesProcessor
    * @function
    *
    * @description
    * This function can be used to get an observable object for processed expired licenses.
    * @returns {Object} an observable object for processed expired licenses.
    */
    getObservable() {

        return observableProcessedExpiredLicenses;

    },

};

const subjectExpiredLicensesRepository = ExpiredLicensesRepository.getObservable();

subjectExpiredLicensesRepository.subscribe(
    data => ExpiredLicensesProcessor.onNext(data),
    () => { },
    () => { },
);

export default ExpiredLicensesProcessor;



// WEBPACK FOOTER //
// ./scripts/common/repositoryProcessors/-RFC.expiredLicensesProcessor.js